// import { BranchModel, StaffDto, CustomerViewModel } from '../../../api/models/web-app.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from './../../../layout/main/base.component';
import { Component, OnInit } from '@angular/core';

import { Customer, ItemCode, ProcessStatus } from 'src/app/api/models/web-booking.models';

@Component({
  selector: 'app-select-practitioner',
  templateUrl: './select-practitioner.component.html',
  styleUrls: ['./select-practitioner.component.css']
})
export class SelectPractitionerComponent extends BaseComponent implements OnInit {

  public therapists = [];
  public selectedTherapist: any;
  public selectedService: ItemCode[];

  customer: Customer;
  hastNewClientTreatment = false;

  ngOnInit(): void {
    if (this.app.branch === null) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    if (this.app.stringService.isEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment))) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    if (localStorage.getItem(AppConstants.BookingProcessStatus) === ProcessStatus.ConfirmAppointment.toString()) {
      this.app.router.navigate([AppConstants.RouteServiceConfirmation]);
      return;
    }
    this.selectedService = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment));
    this.baseTriggerChild.subscribe(event => {
      this.getTherapis();
    });
    this.start();
  }

  getTherapis(): void {
    const model = {
      branchId: this.app.branch.branchId,
      specialityIds: []
    };
    for (let a = 0; a < this.selectedService.length; a++) {
      if (this.selectedService[a].itemCodeType === 9 &&
        this.selectedService[a].packageItems != null &&
        this.selectedService[a].packageItems.length > 0) {
        for (const item of this.selectedService[a].packageItems) {
          model.specialityIds.push(item.specialityId);
        }
      }
      else {
        model.specialityIds.push(this.selectedService[a].specialityId);
      }

      if (!this.selectedService[a].newClientTreatment) {
        this.hastNewClientTreatment = true;
      }
    }

    this.app.spinner.show();
    this.app.webBookingService.GetTherapists(model)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.therapists = data;
          if (this.therapists != null && this.therapists.length > 0) {
            const idontMind = { firstName: 'First', lastName: 'Available Practitioner', therapistId: '', consultationTimes: null };
            this.therapists.unshift(idontMind);
            this.selectedTherapist = idontMind;
          }
          // if (!this.hastNewClientTreatment) {            
          //   const idontMind = { firstName: 'First', lastName: 'Available Practitioner', therapistId: '', consultationTimes: null };
          //   this.therapists.unshift(idontMind);
          //   this.selectedTherapist = idontMind;
          // }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  setSelectedPractitioner(practitioner: any): void {
    // if (practitioner.firstName == 'First') {
    //   practitioner = this.therapists[1];
    // }
    this.app.storageService.setItem(AppConstants.SelectedPractitioner, JSON.stringify(practitioner));
    this.app.router.navigate([AppConstants.RouteSelectDate]);
  }

  back(): void {
    this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
    this.app.router.navigate([AppConstants.RouteSelectConsultation]);
  }

  //#region User Session Helper
  isLogin(): boolean {
    const token = this.app.storageService.getItem(AppConstants.Token);
    const customer = this.app.storageService.getItem(AppConstants.Customer);
    this.customer = JSON.parse(customer) as Customer;
    if (this.app.stringService.isNotEmpty(customer) && this.app.stringService.isNotEmpty(token)) {
      return true;
    }
    return false;
  }

  logout(): void {
    this.app.storageService.removeItem(AppConstants.Customer);
    this.app.storageService.removeItem(AppConstants.Token);
  }
  //#endregion
}
